import React from 'react'

import { RecipeTile as PureRecipeTile } from '@features/recipe-tile'
import { RecipeTileProps } from '@features/recipe-tile/src/components/RecipeTile'
import type { RecipeCoreId, RecipeUUID } from '@library/menu-service'

import { useIsRecipeInStock } from 'hooks/menu-recipes/useIsRecipeInStock'
import { useRecipeOptions } from 'routes/Menu/domains/menu'

export const RecipeTile = (props: Omit<RecipeTileProps, 'alternativeOptions' | 'isOutOfStock'>) => {
  const { recipeV2, currentCollectionId } = props
  const alternativeOptions = useRecipeOptions(currentCollectionId, recipeV2.id as RecipeCoreId)
  const isOutOfStock = !useIsRecipeInStock(recipeV2.uuid as RecipeUUID)

  return (
    <PureRecipeTile
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      alternativeOptions={alternativeOptions}
      isOutOfStock={isOutOfStock}
    />
  )
}
